import React from 'react';
import { CenteredMessage } from './CenteredMessage';

function EvaluationComponent({ evaluation, endedReason }) {
    return (
        <div style={{ height: 'auto' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
            }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#1f2937',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    Evaluation
                </div>
            </div>

            <div style={{
                height: '100%',
                overflowY: 'auto',
                padding: '20px',
                backgroundColor: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e2e8f0'
            }}>
                {/* Evaluation block */}
                {evaluation !== undefined ? (
                    <div style={{
                        marginBottom: '16px',
                        padding: '12px',
                        backgroundColor: (typeof evaluation === 'string' ? evaluation === 'true' : String(evaluation) === 'true') ? 'green' : 'red',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}>
                        <p style={{ margin: 0, color: 'white', textAlign: 'center' }}>
                            {(typeof evaluation === 'string' ? evaluation === 'true' : String(evaluation) === 'true')
                                ? 'Passed'
                                : evaluation === false
                                    ? 'Failed to evaluate the call.'
                                    : String(evaluation)}
                        </p>
                    </div>
                ) : (
                    <CenteredMessage text="No transcript available" />
                )}

                {/* Ended Reason block */}
                {endedReason && (
                    <div style={{
                        marginTop: '8px',
                        padding: '12px',
                        backgroundColor: '#e2e8f0',
                        borderRadius: '8px',
                        fontSize: '14px',
                        color: '#1f2937'
                    }}>
                        <strong>Ended Reason:</strong> {endedReason}
                    </div>
                )}
            </div>
        </div>
    );
}

export default EvaluationComponent;
